import { CustomRefContext } from "contexts/RefContext";
import { useContext }       from "react";

export const useCustomRef = () => useContext(CustomRefContext)
